function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var numToFixed = function numToFixed(number) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return parseFloat(number.toFixed(decimal));
};
var paramStr = function paramStr(obj) {
  var list = [];

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var value = obj[key];
      list.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value === null ? '' : value)));
    }
  }

  return "?".concat(list.join('&').replace(/%20/g, '+'));
};
var createUuid = function createUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
var getTimestamp = function getTimestamp() {
  return new Date().getTime();
};
var isMobile = function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
};
var sliceParams = function sliceParams(params, maxLength) {
  var MAX_LENGTH = 500;

  if (_typeof(params) === 'object') {
    return JSON.stringify(params).slice(0, maxLength || MAX_LENGTH);
  }

  if (typeof params === 'string') {
    return params.slice(0, maxLength || MAX_LENGTH);
  }
  return '';
};
var getStackMsg = function getStackMsg(err) {
  var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var MaxLength = 500;
  var stack = err.stack || '';
  var stackArr = stack.split('\n');
  var stackSlice = stackArr.slice(0, row).map(function (item) {
    return item.trim();
  }).join('\n');

  if (stackSlice.length > MaxLength) {
    stackSlice = stackSlice.slice(0, 500);
  }

  return stackSlice;
};
var hostFirstStr = window && window.location.host.split('.')[0] || '';
var getEnv = {
  isDev: function isDev() {
    return hostFirstStr.indexOf('dev-') !== -1 || hostFirstStr.indexOf('localhost') !== -1;
  },
  isTest: function isTest() {
    return hostFirstStr.indexOf('test-') !== -1;
  },
  isStaging: function isStaging() {
    return hostFirstStr.indexOf('staging-') !== -1;
  },
  isProduction: function isProduction() {
    return !this.isDev() && !this.isTest() && !this.isStaging();
  }
};

var PlatformEnum;

(function (PlatformEnum) {
  PlatformEnum["pc"] = "pc";
  PlatformEnum["h5"] = "h5";
  PlatformEnum["ios"] = "ios";
  PlatformEnum["android"] = "android";
  PlatformEnum["hybrid_ios"] = "h_ios";
  PlatformEnum["hybrid_android"] = "h_and";
  PlatformEnum["wx_mina"] = "wx_mina";
})(PlatformEnum || (PlatformEnum = {}));

var MonitorTypeEnum;

(function (MonitorTypeEnum) {
  MonitorTypeEnum["PERF"] = "perf";
  MonitorTypeEnum["SPEED"] = "speed";
  MonitorTypeEnum["API"] = "api";
  MonitorTypeEnum["JSERROR"] = "jserror";
  MonitorTypeEnum["MONITOR_ERROR"] = "merr";
})(MonitorTypeEnum || (MonitorTypeEnum = {}));

var createImgReporter = function createImgReporter(reporter) {
  var src = reporter.url + paramStr(reporter.reportData);
  var img = new Image();
  img.src = src;

  img.onload = function () {
    reporter.onSuccess && reporter.onSuccess();
  };

  img.onerror = function () {
    reporter.onError && reporter.onError();
  };
};

var report = function report(params) {
  var globalData = GlobalControl.getGlobal();
  var commonData = {
    dom: globalData.domain,
    r: 1,
    sid: globalData.sid,
    s: globalData.source,
    p: globalData.path,
    pt: globalData.platform
  };
  var d = params.d,
      dt = params.dt,
      r = params.r,
      onSuccess = params.onSuccess,
      onError = params.onError;
  var reportData = Object.assign(Object.assign({}, commonData), {
    d: JSON.stringify(d),
    dt: dt,
    r: r || 1
  });
  var url = globalData.reportApi;
  createImgReporter({
    url: url,
    reportData: reportData,
    onSuccess: onSuccess,
    onError: onError
  });
};

var reportMonitorError = function reportMonitorError(err) {
  var dt = MonitorTypeEnum.MONITOR_ERROR;
  var d = {
    msg: getStackMsg(err)
  };
  report({
    dt: dt,
    d: d,
    r: 1
  });
};

var onload = function onload(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
};

var getDeviceInfo = function getDeviceInfo() {
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var ua = navigator.userAgent.toLocaleLowerCase();

  var testUa = function testUa(reg) {
    return reg.test(ua);
  };

  var browser = 'other';

  if (testUa(/applewebkit/g)) {
    if (testUa(/edge/g)) {
      browser = 'edge';
    } else if (testUa(/opr/g)) {
      browser = 'opera';
    } else if (testUa(/chrome/g)) {
      browser = 'chrome';
    } else if (testUa(/safari/g)) {
      browser = 'safari';
    }
  } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
    browser = 'firefox';
  } else if (testUa(/presto/g)) {
    browser = 'opera';
  } else if (testUa(/trident|compatible|msie/g)) {
    browser = 'ie';
  }

  return {
    screenWidth: screenWidth,
    screenHeight: screenHeight,
    browser: browser
  };
};

var REPORT_API = function () {
  var api = 'https://qms-monitor.codemao.cn/quality/monitor/report';

  if (getEnv.isDev() || getEnv.isTest() || getEnv.isStaging()) {
    api = 'https://dev-qms-monitor.codemao.cn/quality/monitor/report';
  }
  return api;
}();

var DOMAIN = window.location.host || '';
var ConfigControl = {
  _config: {
    reportApi: REPORT_API,
    domain: DOMAIN,
    platform: isMobile() ? PlatformEnum.h5 : PlatformEnum.pc,
    enableSpeed: true,
    enableApi: true,
    enableJsError: true
  },
  getConfig: function getConfig(key) {
    if (key) {
      return this._config[key];
    }

    return this._config;
  },
  setConfig: function setConfig(config) {
    this._config = Object.assign(Object.assign({}, this._config), config);
  }
};
var SID = createUuid();
var USER_AGENT = window.navigator.userAgent;
var SOURCE = window.location.href;
var _window$location = window.location,
    origin = _window$location.origin,
    pathname = _window$location.pathname;
var GlobalControl = {
  _global: null,
  _initGlobalData: function _initGlobalData() {
    this._global = {
      reportApi: ConfigControl.getConfig('reportApi'),
      domain: ConfigControl.getConfig('domain'),
      sid: SID,
      source: SOURCE,
      path: "".concat(origin).concat(pathname),
      ua: USER_AGENT,
      platform: ConfigControl.getConfig('platform')
    };
  },
  getGlobal: function getGlobal() {
    return this._global;
  },
  setGlobal: function setGlobal(globalData) {
    this._global = Object.assign(Object.assign({}, globalData), this._global);
  }
};

var getPerfermanceTiming = function getPerfermanceTiming() {
  var entries = window.performance.getEntriesByType('navigation');
  var entryTiming = entries[0];
  return entryTiming;
};

var getPageTiming = function getPageTiming() {
  var timing = getPerfermanceTiming();
  var redirectEnd = timing.redirectEnd,
      redirectStart = timing.redirectStart,
      domainLookupEnd = timing.domainLookupEnd,
      domainLookupStart = timing.domainLookupStart,
      connectEnd = timing.connectEnd,
      connectStart = timing.connectStart,
      requestStart = timing.requestStart,
      secureConnectionStart = timing.secureConnectionStart,
      responseEnd = timing.responseEnd,
      responseStart = timing.responseStart,
      domInteractive = timing.domInteractive;
      timing.domContentLoadedEventEnd;
      var loadEventStart = timing.loadEventStart,
      fetchStart = timing.fetchStart;
  var pageTiming = {
    redirect: numToFixed(redirectEnd - redirectStart),
    dns: numToFixed(domainLookupEnd - domainLookupStart),
    tcp: numToFixed(connectEnd - connectStart),
    ssl: numToFixed(requestStart - secureConnectionStart),
    req: numToFixed(responseStart - requestStart),
    res: numToFixed(responseEnd - responseStart),
    domParse: numToFixed(domInteractive - responseEnd),
    resourceLoad: numToFixed(loadEventStart - domInteractive),
    load: numToFixed(loadEventStart - fetchStart)
  };
  return pageTiming;
};

var observe = function observe(type, callback) {
  var po = new PerformanceObserver(function (l) {
    return l.getEntries().map(callback);
  });
  po.observe({
    type: type,
    buffered: true
  });
  return po;
};

var getCLS = function getCLS() {
  return new Promise(function (resolve, reject) {
    var cls = 0;

    try {
      var entryHandler = function entryHandler(entry) {
        if (!entry.hadRecentInput) {
          cls += entry.value;
        }
      };

      var po = observe('layout-shift', entryHandler);

      var stopListening = function stopListening() {
        po.takeRecords().map(function (entry) {
          if (entry.hadRecentInput) {
            cls += entry.value;
          }
        });
        po.disconnect();
        resolve(cls);
      };

      addEventListener('pageshow', stopListening, {
        once: true,
        capture: true
      });
    } catch (error) {
      console.log('get CLS error', error);
      reject(error);
    }
  });
};

var getFCP = function getFCP() {
  return new Promise(function (resolve, reject) {
    try {
      var entryHandler = function entryHandler(entry) {
        if (entry.name === 'first-contentful-paint') {
          if (po) {
            po.disconnect();
          }

          var fcp = entry.startTime;
          resolve(fcp);
        }
      };

      var po = observe('paint', entryHandler);
    } catch (error) {
      console.log('get FCP error', error);
      reject(error);
    }
  });
};

var onHidden = function onHidden(cb, once) {
  var onHiddenOrPageHide = function onHiddenOrPageHide(event) {
    if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
      cb(event);

      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };

  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  addEventListener('pagehide', onHiddenOrPageHide, true);
};

var firstHiddenTime = document.visibilityState === 'hidden' ? 0 : Infinity;

var getFirstHiddenTime = function getFirstHiddenTime() {
  onHidden(function (e) {
    firstHiddenTime = Math.min(firstHiddenTime, e.timeStamp);
  }, true);
  return {
    get timeStamp() {
      return firstHiddenTime;
    }

  };
};

var getFID = function getFID() {
  return new Promise(function (resolve, reject) {
    var fid = -1;

    try {
      var firstHiddenTime = getFirstHiddenTime();

      var entryHandler = function entryHandler(entry) {
        var delay = entry.processingStart - entry.startTime;

        if (entry.startTime < firstHiddenTime.timeStamp) {
          if (po) {
            po.disconnect();
          }

          fid = delay;
          resolve(fid);
        }
      };

      var po = observe('first-input', entryHandler);

      if (po) {
        onHidden(function () {
          po.takeRecords().map(entryHandler);
          po.disconnect();
          setTimeout(function () {
            resolve(fid);
          }, 10000);
        }, true);
      }
    } catch (error) {
      console.log('get FID error', error);
      reject(error);
    }
  });
};

var getLCP = function getLCP() {
  return new Promise(function (resolve, reject) {
    try {
      var firstHiddenTime = getFirstHiddenTime();

      var entryHandler = function entryHandler(entry) {
        if (entry.startTime < firstHiddenTime.timeStamp) {
          var lcp = entry.startTime;
          resolve(lcp);
        }
      };

      var po = observe('largest-contentful-paint', entryHandler);

      if (po) {
        var stopListening = function stopListening() {
          po.disconnect();
        };

        ['keydown', 'click'].forEach(function (type) {
          addEventListener(type, stopListening, {
            once: true,
            capture: true
          });
        });
      }
    } catch (error) {
      console.log('get LCP error', error);
      reject(error);
    }
  });
};

var getTTFB = function getTTFB() {
  return new Promise(function (resolve, reject) {
    try {
      var ttfb = getPerfermanceTiming().responseStart;
      resolve(ttfb);
    } catch (error) {
      console.log('get TTFB error', error);
      reject(error);
    }
  });
};

var getTTI = function getTTI() {
  return new Promise(function (resolve, reject) {
    try {
      var _getPerfermanceTiming = getPerfermanceTiming(),
          domInteractive = _getPerfermanceTiming.domInteractive,
          fetchStart = _getPerfermanceTiming.fetchStart;

      var tti = domInteractive - fetchStart;
      resolve(tti);
    } catch (error) {
      console.log('get TTI error', error);
      reject(error);
    }
  });
};

var initSpeed = function initSpeed() {
  try {
    onload(function () {
      var speedData = getPageTiming();
      var deviceData = getDeviceInfo();
      var dt = MonitorTypeEnum.PERF;
      var d = Object.assign(Object.assign({}, speedData), deviceData);
      report({
        dt: dt,
        d: d
      });
      dt = MonitorTypeEnum.SPEED;
      var vitals = [getCLS(), getFCP(), getFID(), getLCP(), getTTFB(), getTTI()];
      Promise.all(vitals).then(function (values) {
        var d = {
          cls: numToFixed(values[0]),
          fcp: numToFixed(values[1]),
          fid: numToFixed(values[2]),
          lcp: numToFixed(values[3]),
          ttfb: numToFixed(values[4]),
          tti: numToFixed(values[5])
        };
        report({
          dt: dt,
          d: d
        });
      })["catch"](function (err) {
        console.log('err', err);
      });
    });
  } catch (error) {
    reportMonitorError(error);
  }
};

var ENUM_APITYPE;

(function (ENUM_APITYPE) {
  ENUM_APITYPE[ENUM_APITYPE["SUCCESS"] = 1] = "SUCCESS";
  ENUM_APITYPE[ENUM_APITYPE["BUSINESS_ERROR"] = 2] = "BUSINESS_ERROR";
  ENUM_APITYPE[ENUM_APITYPE["REQUEST_ERROR"] = 3] = "REQUEST_ERROR";
})(ENUM_APITYPE || (ENUM_APITYPE = {}));

var RATE = 10;
var BUSINESS_ERROR_CODE = [400, 499];
var CUSTOM_API_ERROR = {
  network: {
    code: '601',
    msg: 'Network Error'
  },
  timeout: {
    code: '602',
    msg: 'timeout'
  },
  abort: {
    code: '603',
    msg: 'abort'
  },
  fetchErrpr: {
    code: '604',
    msg: 'fetchError'
  }
};

var rewriteXHR = function rewriteXHR() {
  if (!window || !window.XMLHttpRequest) {
    return;
  }

  var _xhr = new XMLHttpRequest();

  var _open = _xhr.open;
  var _send = _xhr.send;

  var _GlobalControl$getGlo = GlobalControl.getGlobal(),
      reportApi = _GlobalControl$getGlo.reportApi;

  XMLHttpRequest.prototype.open = function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    try {
      var method = args[0],
          url = args[1],
          async = args[2];
      this._startTime = getTimestamp();
      this._apiUrl = url.indexOf('?') === -1 ? url : url.split('?')[0];
      this._apiUrlParams = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?'));
      this._method = method.toUpperCase();

      if ('onloadend' in this) {
        this.addEventListener('loadend', function () {
          setTimeout(function () {
            return handleApiComplete.call(_this);
          });
        });
      } else {
        this.addEventListener('readystatechange', function () {
          if (_this.readyState === 4) {
            setTimeout(function () {
              return handleApiComplete.call(_this);
            });
          }
        });
      }

      this.addEventListener('error', function () {
        handleApiComplete.call(_this, CUSTOM_API_ERROR.network);
      });
      this.addEventListener('abort', function () {
        handleApiComplete.call(_this, CUSTOM_API_ERROR.abort);
      });
      this.addEventListener('timeout', function () {
        handleApiComplete.call(_this, CUSTOM_API_ERROR.timeout);
      });
    } catch (error) {
      reportMonitorError(error);
    }

    return _open.apply(this, args);
  };

  XMLHttpRequest.prototype.send = function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (this._method === 'POST') {
      this._reqData = args[0];
    }

    return _send.apply(this, args);
  };

  function handleApiComplete(errorParams) {
    if (this._isReport) {
      return;
    }

    var apiData = {
      api: this._apiUrl,
      t: getTimestamp() - this._startTime,
      mode: 'xhr',
      type: -1,
      status: this.status || 0,
      ecode: '',
      msg: '',
      params: '',
      method: this._method || 'GET'
    };
    var rate = RATE;
    var dt = MonitorTypeEnum.API;

    if (apiData.api.indexOf(reportApi) !== -1) {
      console.warn('当前请求的api链接与上报链接重复');
      return;
    }

    if (this.status >= 200 && this.status <= 299) {
      rate = RATE;
      apiData.type = ENUM_APITYPE.SUCCESS;
    } else {
      rate = 1;

      if (this._method.toUpperCase() === 'POST') {
        apiData.params = JSON.stringify(this._reqData);
      } else {
        apiData.params = sliceParams(this._apiUrlParams);
      }

      if (this.status >= BUSINESS_ERROR_CODE[0] && this.status <= BUSINESS_ERROR_CODE[1]) {
        var response = {};

        try {
          response = JSON.parse(this.response || '{}');
        } catch (error) {
          console.log('web monitor sdk parse error', error);
        }

        apiData.type = ENUM_APITYPE.BUSINESS_ERROR;
        apiData.ecode = response.code || response.error_code || response.errorCode || '-1';
        apiData.msg = response.msg || response.error_message || response.errorMessage || '';
      } else {
        apiData.type = ENUM_APITYPE.REQUEST_ERROR;
        apiData.ecode = errorParams && errorParams.code || '';
        apiData.msg = errorParams && errorParams.msg || '';
      }
    }

    this._isReport = true;

    if (Math.random() < 1 / rate) {
      report({
        dt: dt,
        d: apiData,
        r: rate
      });
    }
  }
};

var rewriteFetch = function rewriteFetch() {
  if (!window || !window.fetch) return;
  var _fetch = fetch;

  var newFetch = function newFetch(url, config) {
    var _startTime = getTimestamp();

    var method = config && config.method || 'GET';
    var dt = MonitorTypeEnum.API;

    var _apiUrl = url.indexOf('?') === -1 ? url : url.split('?')[0];

    var _apiUrlParams = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?'));

    var apiData = {
      api: _apiUrl,
      t: -1,
      mode: 'fetch',
      type: -1,
      status: 0,
      ecode: '',
      msg: '',
      params: '',
      method: method.toUpperCase()
    };
    var rate = RATE;
    return _fetch.apply(window, [url, config]).then(function (res) {
      var _res = res.clone();

      var status = _res.status;
          _res.headers;
      apiData.t = getTimestamp() - _startTime;
      apiData.status = status;

      _res.text().then(function (data) {
        try {
          if (status >= 200 && status <= 299) {
            handleApiSuccess();
          } else {
            handleApiError(status, '', '', data);
          }

          if (Math.random() < 1 / rate) {
            report({
              dt: dt,
              d: apiData,
              r: rate
            });
          }
        } catch (error) {
          reportMonitorError(error);
        }
      });

      return res;
    }, function (err) {
      var ecode = CUSTOM_API_ERROR.fetchErrpr.code;
      var msg = '';

      try {
        msg = "".concat(err.name, ": ").concat(err.message);
      } catch (error) {
        msg = CUSTOM_API_ERROR.fetchErrpr.msg;
      }

      handleApiError(0, ecode, msg, '');
      report({
        dt: dt,
        d: apiData,
        r: rate
      });
      throw err;
    });

    function handleApiSuccess() {
      rate = RATE;
      apiData.type = ENUM_APITYPE.SUCCESS;
    }

    function handleApiError(status, ecode, errorMessage, resText) {
      rate = 1;
      apiData.t = getTimestamp() - _startTime;
      apiData.status = status;

      if (apiData.method === 'POST') {
        apiData.params = JSON.stringify(config === null || config === void 0 ? void 0 : config.body);
      } else {
        apiData.params = sliceParams(_apiUrlParams);
      }

      if (resText && status >= BUSINESS_ERROR_CODE[0] && status <= BUSINESS_ERROR_CODE[1]) {
        apiData.type = ENUM_APITYPE.BUSINESS_ERROR;
        var response = {};

        try {
          response = JSON.parse(resText || '{}');
        } catch (error) {
          console.log('web monitor sdk parse error', error);
        }

        apiData.ecode = response.code || response.error_code || response.errorCode || '';
        apiData.msg = response.msg || response.error_message || response.errorMessage || '';
      } else {
        apiData.type = ENUM_APITYPE.REQUEST_ERROR;
        apiData.ecode = ecode;
        apiData.msg = sliceParams(resText) || errorMessage;
      }
    }
  };

  window.fetch = newFetch;
};

var initApi = function initApi() {
  try {
    rewriteXHR();
    rewriteFetch();
  } catch (error) {
    reportMonitorError(error);
  }
};

var WebMonitor = function WebMonitor(config) {
  _classCallCheck(this, WebMonitor);

  try {
    ConfigControl.setConfig(config || {});

    GlobalControl._initGlobalData();

    var _ConfigControl$getCon = ConfigControl.getConfig(),
        enableSpeed = _ConfigControl$getCon.enableSpeed,
        enableApi = _ConfigControl$getCon.enableApi,
        enableJsError = _ConfigControl$getCon.enableJsError;

    enableSpeed && initSpeed();
    enableApi && initApi();
  } catch (error) {
    console.log('init monitor sdk error', error);
  }
};

export { WebMonitor };
